module.exports = __webpack_public_path__ + "static/media/copy-icon-white-24x24.2efc7410.svg";